<template>
  <section id="footer_main">
    <nav>
      <ul>
        <li><a @click="route('DcTop')">トップページ</a></li>
        <li v-if="!isHaseko"><a @click="route('DcAbout')">初めての方へ</a></li>
        <li v-else><a @click="route('DcAbout2')">初めての方へ</a></li>
        <li><a @click="route('DcPaymentGuide')">ご購入ガイド</a></li>
        <li><a @click="route('Cart')">カート</a></li>
        <li><a @click="route('Faq')">よくある質問</a></li>
        <li><a @click="route('SupportInput')">お問い合わせ</a></li>
        <li><a @click="route('DcCorpInformation')">会社案内</a></li>
      </ul>
    </nav>
    <div id="copyright">Copyright ©{{year}} domans all rights reserved. </div>
  </section>
</template>
<script>
import * as App from '../../../utils/App'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../../constants/App'

export default {
  name: 'DcFooter',
  components: {
  },
  props: {
  },
  data () {
    return {
      year: undefined,
      user: {}
    }
  },
  computed: {
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  methods: {
    route: function (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    }
  },
  mounted: function () {
  },
  created: function () {
    let date = new Date()
    this.year = date.getFullYear()
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dcheader.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/DcFooter.vue